import Vue from 'vue';
import Vuex from 'vuex';
import { post, get } from '../services/http';
import ZD_Action from './ZD_Interface';
import common_Action from './common_interface';
import areaCode from './modules/areaCode'
import password from './modules/password'
Vue.use(Vuex);

const actions = {};
getActions(ZD_Action);
getActions(common_Action);
export default new Vuex.Store({
    state: {
        keepAlivePage: [], // 需要缓存的页面，
        downloadDialogShow: false,
        area: 1,//用户片区编号
        areaList: null,//可用片区列表(通常房客用)
    },
    getters: {
        keepAlivePage: state => state.keepAlivePage, // 获取需要缓存的页面
        downloadDialogShow: state => state.downloadDialogShow, // 获取需要缓存的页面
        area(state) {
            if (state.area === null) {
                let localArea = localStorage.getItem("localArea");
                if (localArea) return state.area = parseInt(localArea);
                else return state.area = 1;
            }
            return state.area;
        },
        areaList(state) {
            if (state.areaList === null) {
                let localAreaList = localStorage.getItem("localAreaList");
                if (localAreaList) return state.areaList = JSON.parse(localAreaList);
                else return state.areaList = [];
            }
            return state.areaList;
        },
    },
    mutations: {
        ADD_KEEP_ALVE: (state, name) => {
            if (!state.keepAlivePage.includes(name))
                state.keepAlivePage = state.keepAlivePage.concat(name);
        },
        DEL_KEEP_ALVE: (state, name) => {
            state.keepAlivePage.map((item, index) => {
                if (item == name)
                    state.keepAlivePage.splice(index, 1);
            })
        },
        showDownload(state, show = false) {
            state.downloadDialogShow = show
        },
        area(state, id) {
            state.area = id;
            localStorage.setItem("localArea", id);
        },
        areaList(state, id) {
            state.areaList = id;
            localStorage.setItem("localAreaList", JSON.stringify(id));
        },
    },
    actions: actions,
    modules: { areaCode, password }
})




function getActions(extraActions) {
    for (const key in extraActions) {
        if (Object.hasOwnProperty.call(actions, key)) {
            console.warn(`${key} has already existed!`);
        } else {
            actions[key] = extraActions[key];
        }
    }
    // if (!isObject(extraActions)) return;
    // const ownerKeys = Object.keys(actions);
    // const extraKeys = Object.keys(extraActions);
    // extraKeys.forEach(key => {
    //     if (ownerKeys.includes(key)) {
    //         console.warn(`${ key } has already existed!`);
    //     } else {
    //         actions[key] = extraActions[key];
    //     }
    // });
}